// extracted by mini-css-extract-plugin
export var cartIcon = "_ou-0";
export var cartIconContainer = "_ou-1";